import { apiClient } from './client';

export function listNotifications (params: Record<string, unknown>) {
  return apiClient.get('/merchant-notifications', { params });
}

export function getNotification (notificationId: number | string) {
  return apiClient.get(`/merchant-notifications/${notificationId}`);
}

export function createNotification (payload: Record<string, unknown>) {
  return apiClient.post('/merchant-notifications', payload);
}

export function updateNotification (notificationId: number | string, payload: Record<string, unknown>) {
  return apiClient.put(`/merchant-notifications/${notificationId}`, payload);
}

export function deleteNotification (notificationId: number | string) {
  return apiClient.delete(`/merchant-notifications/${notificationId}`);
}

export function getStatuses () {
  return apiClient.get('/merchant-notifications/statuses');
}

export function getThemes () {
  return apiClient.get('/merchant-notifications/themes');
}
